(() => {
  const root = document.querySelector('[data-limitless-intro]');
  if (!root) return;

  const STORAGE_KEY = 'limitless_age_verified';
  const designMode = window.Shopify && window.Shopify.designMode;

  // Skip everything for returning verified visitors and in theme editor preview.
  try {
    if (!designMode && window.localStorage.getItem(STORAGE_KEY) === 'true') {
      root.parentNode && root.parentNode.removeChild(root);
      return;
    }
  } catch (e) {
    // localStorage blocked (private mode, etc.) — fall through and show the gate every time.
  }

  // Lock the page and reveal the overlay.
  document.documentElement.classList.add('limitless-age-locked');
  root.hidden = false;
  root.setAttribute('aria-hidden', 'false');

  const video = root.querySelector('[data-limitless-intro-video]');
  const stages = {
    video: root.querySelector('[data-stage="video"]'),
    age: root.querySelector('[data-stage="age"]'),
    blocked: root.querySelector('[data-stage="blocked"]'),
  };

  function showStage(name) {
    Object.keys(stages).forEach((key) => {
      const el = stages[key];
      if (!el) return;
      if (key === name) {
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
  }

  let advanced = false;
  function advanceToAge() {
    if (advanced) return;
    advanced = true;
    if (video) {
      try { video.pause(); } catch (e) {}
    }
    showStage('age');
    // Focus the primary action for keyboard users.
    const focus = root.querySelector('[data-limitless-age-confirm]');
    if (focus) focus.focus();
  }

  // Pick the right video source for this device, then load.
  if (video) {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const src = isMobile ? video.dataset.mobileSrc : video.dataset.desktopSrc;
    const poster = isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
    if (poster) video.poster = poster;
    if (src) {
      video.src = src;
      try { video.load(); } catch (e) {}
    }

    video.addEventListener('ended', advanceToAge);
    video.addEventListener('error', advanceToAge);

    // Best-effort autoplay (muted + playsinline satisfies modern browser policies).
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(advanceToAge);
    }

    // Hard timeout in case the video stalls or its 'ended' never fires.
    const expectedDurationMs = 6000;
    setTimeout(() => {
      if (!advanced) {
        // If the video is still playing healthily, give it a small grace window;
        // otherwise force-advance.
        if (video.duration && !isNaN(video.duration) && video.currentTime < video.duration - 0.2 && !video.paused) {
          setTimeout(advanceToAge, Math.max(0, (video.duration - video.currentTime) * 1000 + 200));
        } else {
          advanceToAge();
        }
      }
    }, expectedDurationMs);
  } else {
    // No video element — go straight to age verification.
    advanceToAge();
  }

  // Manual skip.
  const skipBtn = root.querySelector('[data-limitless-intro-skip]');
  if (skipBtn) skipBtn.addEventListener('click', advanceToAge);

  // Yes (21+) — confirm and dismiss.
  const confirmBtn = root.querySelector('[data-limitless-age-confirm]');
  if (confirmBtn) {
    confirmBtn.addEventListener('click', () => {
      try { window.localStorage.setItem(STORAGE_KEY, 'true'); } catch (e) {}
      root.classList.add('is-exiting');
      // Wait for the fade-out, then unlock and remove from layout.
      setTimeout(() => {
        root.hidden = true;
        root.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('limitless-age-locked');
      }, 450);
    });
  }

  // No (under 21) — block site entry.
  const denyBtn = root.querySelector('[data-limitless-age-deny]');
  if (denyBtn) {
    denyBtn.addEventListener('click', () => {
      showStage('blocked');
    });
  }
})();
